import React from "react";
import { CircularProgress, Box, Typography } from "@material-ui/core";
import FormattedDate from "components/FormattedDate/FormattedDate";

export const makeTableColumns = () => [
    {
        Header: "#",
        id: "rowNumber",
        width: 30,
        disableSortBy: true,
        Cell: ({ row }) => row.index + 1,
    },
    {
        Header: "Make",
        accessor: "makeSlug",
        Cell: ({ value }) => (
            <Typography style={{ textTransform: "capitalize" }}>{value}</Typography>
        ),
    },
    {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) =>
            value === "PENDING" ? (
                <Box display="flex" alignItems="center">
                    <CircularProgress size={18} style={{ marginRight: 10 }} />
                    <Typography variant="body2" color="textSecondary">
                        Processing...
                    </Typography>
                </Box>
            ) : (
                <Typography style={{ textTransform: "capitalize" }}>{value}</Typography>
            ),
    },
    {
        Header: "Total Records",
        accessor: "rowCountTotal",
        Cell: ({ value }) => value?.toLocaleString("en-US"),
    },
    {
        Header: "Processed",
        accessor: "rowCountInserted",
        Cell: ({ value }) => value?.toLocaleString("en-US"),
    },
    {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => <FormattedDate date={value} />,
    },
];
